import { RecurringPaymentTypes } from '../../types/feedTypes';
import { OnboardingStatus } from '../../types/userTypes';
import { IBadge } from '../Profile/screens/Leaderboard/types';

export interface IUserProfileDetails {
  userProfile: IUserProfile;
  subs?: IUserSubscription[];
  isViewerSelf?: boolean;
  viewerType: UserAccountType;
  accountType: UserAccountType;
  storefrontLink?: string;
  allowChat?: boolean;
  isBlockedFromCommunityEngagement?: boolean;
}

export type UserAccountType = 'creator' | 'subscriber';

export interface IUserProfile {
  name: string;
  profilePicUrl: string;
  createdAt?: string;
  onboarding: OnboardingStatus;
  about?: string;
  styledAbout?: string;

  // community
  isBlockedFromCommunityEngagement?: boolean;

  // gamification
  score?: number;
  leaderboardRank?: number;
  badges?: IBadge[];

  // socials
  instagram?: string;
  twitter?: string;
  facebook?: string;
  youtube?: string;
  linkedin?: string;
}

export enum UserProfileView {
  TQ_CONNECT_PROFILE = 'tq-connect-profile',
  DEFAULT_PROFILE = 'default-profile',
}

export type UserProfileViewType = `${UserProfileView}`;

export interface IUserSubscription {
  _id: string;
  mango: Mango;
  status: string;
}

interface Mango {
  _id: string;
  title: string;
  price: number;
  currency: string;
  description: string;
  recurringType: RecurringPaymentTypes;
}

export enum UserProfileTabs {
  ABOUT = 'about',
  POSTS = 'posts',
  REVIEWS = 'reviews',
  SHOUTOUTS = 'shoutouts',
  PURCHASES = 'purchases',
  REMARKS = 'remarks',
}
